// extracted by mini-css-extract-plugin
export default {"subtitle":"RoomArtifacts_subtitle__KNPVc"};